var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChampionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 6,
    transform: "translate(2.837 4.312)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.614,
    cy: 29.614,
    r: 29.614,
    fill: "#6BBA29"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.478 30.452l8.746 9.839 21.864-21.865"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionIcon);
export default __webpack_public_path__ + "static/media/championIcon.a1a9405f.svg";
export { ForwardRef as ReactComponent };